import {inject} from '@angular/core';
import {CanMatchFn, Router, Routes} from '@angular/router';
import {RolloutConfigService} from './core/services';

const rolloutRegistrationCanMatch: CanMatchFn = () => {
  const rolloutConfig = inject(RolloutConfigService);
  if (rolloutConfig.isActive()) {
    return true;
  }

  return inject(Router).createUrlTree(['/']);
};

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./features/landing/landing.routes').then((m) => m.LANDING_ROUTES),
  },
  {
    path: 'rollout-registration',
    canMatch: [rolloutRegistrationCanMatch],
    loadComponent: () =>
      import('./features/rollout/rollout-registration.component').then(
        (m) => m.RolloutRegistrationComponent
      ),
  },
  {
    path: 'season',
    loadChildren: () =>
      import('./features/team/season.routes').then((m) => m.SEASON_ROUTES),
  },
  {
    path: 'team',
    loadChildren: () =>
      import('./features/team/legacy-team.routes').then((m) => m.LEGACY_TEAM_ROUTES),
  },
  {
    path: 'partners',
    loadChildren: () =>
      import('./features/sponsoring/sponsoring.routes').then((m) => m.SPONSORING_ROUTES),
  },
  {
    path: 'news',
    loadChildren: () =>
      import('./features/news/news.routes').then((m) => m.newsRoutes),
  },
  {
    path: 'imprint',
    loadComponent: () => import('./features/legal/imprint.component').then(m => m.ImprintComponent),
  },
  {
    path: 'privacy',
    loadComponent: () => import('./features/legal/privacy.component').then(m => m.PrivacyComponent),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
